export default {
  title: 'We are a full-service partner known for creating beautiful products that people want, engineered on technology that\'s built to last.',
  stroke: 'cases',
  firstSideHeading: 'Design/Development',
  secondSideHeading: 'Collaboration',
};
